import { PurchasingAction } from '@daymade/common-lib/dbEnums';
import { Game } from 'constants/Game';

export const getTicketTypeText = (
  drawTypeCode: string,
  hidePurchaseDate: boolean,
  purchasingAction: PurchasingAction
) => {
  let showPurchaseDate = true;
  if (hidePurchaseDate || drawTypeCode === Game.DailyChallenger.id) {
    showPurchaseDate = false;
  }
  let ticketTypeText = '';
  switch (purchasingAction) {
    case PurchasingAction.PRIZE:
      ticketTypeText = 'DAYMADE Treat';
      break;
    case PurchasingAction.POSTAL:
      ticketTypeText = '(postal entry)';
      break;
    case PurchasingAction.SUBSCRIPTION:
      ticketTypeText = '(subscription renewal)';
      break;
    case PurchasingAction.WINNER_CONTENT:
      ticketTypeText = '(thanks for the photo!)';
      break;
    case PurchasingAction.PROMO:
      ticketTypeText = '(promo)';
      break;
    default:
      break;
  }
  return { ticketTypeText, showPurchaseDate };
};
